import axios, { AxiosRequestConfig } from 'axios'
import { env } from 'src/utils/env'

export const getInfoPageDetail = async (config?: AxiosRequestConfig) => {
  return await axios.get(`${env.BASE_MAGNOLIA_REST_URL}/delivery/info-page`, {
    ...config,
    params: { ...config.params, orderBy: 'publish desc' }
  })
}
